export enum WindowTypeEnum {
  AWNING = "awning",
  SINGLE_OR_DOUBLE ="single or double hung",
  CASEMENT = "casement",
  BAY_N_BOW = "bay & bow",
  PASS_THRU = "pass-thru",
  GLIDING = "gliding",
  SPECIALTY = "specialty",
  PICTURE = "picture",
}